<template>
  <el-container v-title data-title="学生列表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
                <el-breadcrumb-item>学生列表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.realName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="班级" filterable>
                  <el-select v-model="searchForm.classId">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in outerSelectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否过期">
                  <el-select v-if="userInfo.userType === '1'" v-model="searchForm.isExpired" placeholder="是否过期">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已过期" value="1"></el-option>
                    <el-option label="未过期" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="卡号">
                  <el-input v-model="searchForm.cardNo" placeholder="卡号"></el-input>
                </el-form-item>
                <el-form-item label="家长电话">
                  <el-input v-model="searchForm.parentMobile" placeholder="家长电话"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码">
                  <el-input v-model="searchForm.idCardNo" placeholder="身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="是否删除">
                  <el-select v-model="searchForm.status" placeholder="是否删除">
                    <el-option label="未删除" value="1"></el-option>
                    <el-option label="已删除" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="getUserList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog" v-if="['1'].indexOf(userInfo.userType) != -1">新增</el-button>
                  <el-button v-if="searchForm.schoolId != ''" type="primary" :loading="isDownloading" @click="downloadStudentList">下载</el-button>
                  <!-- <el-button v-if="searchForm.schoolId != '' && ['1'].indexOf(userInfo.userType) != -1" type="primary" :loading="isSyncMeetingFacePic" @click="syncMeetingFacePicToWechatPhone(searchForm.schoolId)">同步到电话</el-button> -->
                  <el-button v-if="searchForm.schoolId != '' && ['1'].indexOf(userInfo.userType) != -1" type="primary" :loading="isSyncMeetingFacePic" @click="syncMeetingFacePicToTianqiao(searchForm.schoolId)">同步到天乔</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" fixed></el-table-column>
          <el-table-column prop="className" label="班级" width="90" fixed></el-table-column>
          <el-table-column prop="realName" label="姓名" fixed></el-table-column>
          <el-table-column prop="cardNo" label="卡号" width="110" fixed></el-table-column>
          <el-table-column prop="cardNo2" label="卡号2" width="110" fixed></el-table-column>
          <el-table-column prop="userName" label="用户名" width="145"></el-table-column>
          <el-table-column prop="no" label="学号"></el-table-column>
          <el-table-column prop="genderName" label="性别" width="50"></el-table-column>
          <el-table-column prop="idCardNo" label="身份证号码" width="180"></el-table-column>
          <el-table-column prop="studentTypeName" label="学生类型"></el-table-column>
          <el-table-column prop="isBoarderName" label="是否住校生" width="100"></el-table-column>
          <el-table-column prop="statusName" label="状态"></el-table-column>
          <el-table-column prop="expiredTime" label="到期时间" width="160"></el-table-column>
          <el-table-column prop="parentMobile1" label="家长手机号码1" width="115"></el-table-column>
          <el-table-column prop="parentMobile2" label="家长手机号码2" width="115"></el-table-column>
          <el-table-column prop="openForCanteenName" label="是否点餐" width="78"></el-table-column>
          <el-table-column prop="studentCanteenStopSupperName" label="是否关闭晚餐" width="78"></el-table-column>
          <el-table-column label="人脸图片" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.meetingFacePicUrl != null && scope.row.meetingFacePicUrl.length > 0" :src="GLOBAL.picUrl + scope.row.meetingFacePicUrl" width="64" height="36" @click="openMeetingFacePicDialog(GLOBAL.picUrl + scope.row.meetingFacePicUrl)"/>
            </template>
          </el-table-column>
          <el-table-column label="关联的家长手机号码和用户名" width="370">
            <template slot-scope="scope">
              <div v-for="(mobileAndVideoPhoneBindingStatusMap, userName) in scope.row.parentUserNameToMobileAndVideoPhoneBindingStatusMap" :key="userName">
                {{mobileAndVideoPhoneBindingStatusMap['mobile']}} {{userName}} {{mobileAndVideoPhoneBindingStatusMap['videoPhoneBindingStatusName']}}
                <el-button v-if="['1'].indexOf(userInfo.userType) != -1" type="text" @click="unbindParent(userName)">解绑</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" v-if="['1', '2'].indexOf(userInfo.userType) != -1">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)" v-if="userInfo.userType === '1' || userInfo.userType === '2' && (userInfo.facultyAdminAndNotAdmin || userInfo.allowEditClassIdList != null && userInfo.allowEditClassIdList.indexOf(scope.row.classId) >= 0)">修改</el-button>
              <el-button type="text" @click="changeStatus(scope.row)" v-if="userInfo.userType === '1' || userInfo.userType === '2' && (userInfo.facultyAdminAndNotAdmin || userInfo.allowEditClassIdList != null && userInfo.allowEditClassIdList.indexOf(scope.row.classId) >= 0)">{{ scope.row.status == '1' ? '删除' : '恢复' }}</el-button>
              <!-- <el-button type="text" @click="openUnbindParentDialog(scope.row)" v-if="userInfo.userType === '1'">解绑</el-button> -->
              <!-- <el-button type="text" @click="syncMeetingFacePicToWechatPhone(scope.row.schoolId, scope.row.id)" v-if="scope.row.meetingFacePicUrl != null && scope.row.meetingFacePicUrl.length > 0 && scope.row.meetingFaceToWechatPhoneTime === null && userInfo.userType === '1'">同步到电话</el-button> -->
              <el-button type="text" @click="syncMeetingFacePicToTianqiao(scope.row.schoolId, scope.row.id)" v-if="scope.row.meetingFacePicUrl != null && scope.row.meetingFacePicUrl.length > 0 && scope.row.meetingFaceToTianqiaoTime === null && userInfo.userType === '1'">同步到天乔</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getUserList"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="110px">
          <el-form-item label="姓名" :required="true" prop="userName">
            <el-input v-model="modifyData.realName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="modifyData.schoolId" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" :required="true" prop="classId">
            <el-select v-model="modifyData.classId" filterable>
              <el-option v-for="(item, index) in innerSelectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学号" prop="no">
            <el-input v-model="modifyData.no" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="modifyData.gender" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家长手机号码1" prop="parentMobile1">
            <el-input v-model="modifyData.parentMobile1" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="家长手机号码2" prop="parentMobile2">
            <el-input v-model="modifyData.parentMobile2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idCardNo">
            <el-input v-model="modifyData.idCardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学生类型" prop="studentType">
            <el-select v-model="modifyData.studentType" placeholder="请选择学生类型">
              <el-option label="普通" value="1"></el-option>
              <el-option label="教师子女" value="2"></el-option>
              <el-option label="特困生" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否住校" prop="isBoarder">
            <el-select v-model="modifyData.isBoarder" placeholder="请选择是否住校">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡号" prop="cardNo">
            <el-input v-model="modifyData.cardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号2" prop="cardNo2">
            <el-input v-model="modifyData.cardNo2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="是否点餐" prop="openForCanteen">
            <el-select v-model="modifyData.openForCanteen" placeholder="请选择是否点餐">
              <el-option label="开启点餐" value="1"></el-option>
              <el-option label="关闭点餐" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否关闭晚餐" prop="studentCanteenStopSupper">
            <el-select v-model="modifyData.studentCanteenStopSupper" placeholder="请选择是否关闭晚餐">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyUser">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="110px">
          <!-- <el-form-item label="用户名" :required="true" prop="userName">
            <el-input v-model="addData.userName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="密码" :required="true" prop="password">
            <el-input v-model="addData.password" style="width: 200px"></el-input>
          </el-form-item> -->
          <el-form-item label="姓名" :required="true" prop="realName">
            <el-input v-model="addData.realName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId">
            <el-select v-model="addData.schoolId" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" :required="true" prop="classId">
            <el-select v-model="addData.classId">
              <el-option v-for="(item, index) in innerSelectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学号" prop="no">
            <el-input v-model="addData.no" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="addData.gender" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="家长手机号码1" prop="parentMobile1">
            <el-input v-model="addData.parentMobile1" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="家长手机号码2" prop="parentMobile2">
            <el-input v-model="addData.parentMobile2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idCardNo">
            <el-input v-model="addData.idCardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学生类型" prop="studentType">
            <el-select v-model="addData.studentType" placeholder="请选择学生类型">
              <el-option label="普通" value="1"></el-option>
              <el-option label="教师子女" value="2"></el-option>
              <el-option label="特困生" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否住校" prop="isBoarder">
            <el-select v-model="addData.isBoarder" placeholder="请选择是否住校">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡号" prop="cardNo">
            <el-input v-model="addData.cardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号2" prop="cardNo2">
            <el-input v-model="addData.cardNo2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="是否点餐" prop="openForCanteen">
            <el-select v-model="addData.openForCanteen" placeholder="请选择是否点餐">
              <el-option label="开启点餐" value="1"></el-option>
              <el-option label="关闭点餐" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否关闭晚餐" prop="studentCanteenStopSupper">
            <el-select v-model="addData.studentCanteenStopSupper" placeholder="请选择是否关闭晚餐">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addUser">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="meetingFacePicDialogVisible"
        width="800px"
        :before-close="handleClose"
        :close-on-click-modal="true">
        <img width="760" :src="picUrlOnMeetingFacePicDialog" />
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      isDownloading: false,
      isSyncMeetingFacePic: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        realName: '',
        schoolId: '',
        classId: '',
        isExpired: '',
        status: '1'
      },
      addData: {
        'classId': '',
        'studentType': '1'
      },
      addDialogVisible: false,
      modifyData: {},
      modifyDialogVisible: false,
      rules: {
        // userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
        classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
        parentMobile: [{ required: true, message: '请选择要解绑的家长手机号码', trigger: 'change' }]
      },
      schoolList: [],
      classList: [],
      meetingFacePicDialogVisible: false,
      picUrlOnMeetingFacePicDialog: ''
    }
  },
  mounted () {
    console.log(this.Cookie.get('userInfo'))
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      if (['1', '2'].indexOf(this.userInfo.userType) !== -1) {
        this.getSchoolList()
        this.getClassList()
      }
      this.getUserList()
    }
  },
  created () {
    let _this = this
    document.onkeydown = function (e) {
      if (window.event.keyCode === 13) {
        _this.getUserList()
      }
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getUserList()
    },
    getUserList (currentPage) {
      let _this = this
      _this.currentPage = typeof currentPage === 'number' ? currentPage : _this.currentPage
      let params = {
        currentUserId: _this.userInfo.id,
        page: _this.currentPage,
        size: _this.pageSize,
        realName: _this.searchForm.realName,
        cardNo: _this.searchForm.cardNo,
        parentMobile: _this.searchForm.parentMobile,
        idCardNo: _this.searchForm.idCardNo,
        isExpired: _this.searchForm.isExpired,
        status: _this.searchForm.status,
        schoolId: _this.searchForm.schoolId,
        classId: _this.searchForm.classId
      }
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/user/listStudent',
        this.$qs.stringify(params)
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    downloadStudentList () {
      if (this.searchForm.schoolId === '') return
      let _this = this
      _this.isDownloading = true
      let params = {
        currentUserId: _this.userInfo.id,
        realName: _this.searchForm.realName,
        cardNo: _this.searchForm.cardNo,
        parentMobile: _this.searchForm.parentMobile,
        idCardNo: _this.searchForm.idCardNo,
        isExpired: _this.searchForm.isExpired,
        status: _this.searchForm.status,
        schoolId: _this.searchForm.schoolId,
        classId: _this.searchForm.classId
      }
      this.$axios.post(this.GLOBAL.host + '/user/downloadStudentList',
        this.$qs.stringify(params), {
          responseType: 'blob'
        }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    },
    openModifyDialog (userData) {
      if (userData.classIdList != null && userData.classIdList.length > 0) {
        userData.classId = userData.classIdList[0]
      }
      this.modifyData = JSON.parse(JSON.stringify(userData))
      this.modifyDialogVisible = true
    },
    modifyUser () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          _this.modifyData.userType = 3
          _this.modifyData.password = null
          _this.modifyData.classIdList = [_this.modifyData.classId]
          this.$axios.post(this.GLOBAL.host + '/user/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getUserList()
                _this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addUser () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          _this.addData.userType = 3
          _this.addData.classIdList = [_this.addData.classId]
          this.$axios.post(this.GLOBAL.host + '/user/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData = {
                  'classId': '',
                  'studentType': '1'
                }
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getUserList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    unbindParent (userName) {
      let _this = this
      this.$confirm('确认要解绑家长吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/user/unbindParent', this.$qs.stringify({
          userName: userName
        })).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message.success(res.data.message)
              _this.getUserList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.classList = res.data.data.list != null ? res.data.data.list : []
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    changeStatus (userInfo) {
      if (userInfo === null) return
      let _this = this
      this.$confirm('确认要' + (userInfo.status === '1' ? '删除' : '恢复') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/user/changeStatus',
          this.$qs.stringify({ userId: userInfo.id, status: userInfo.status === '1' ? '0' : '1' })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
            _this.getUserList()
          }
        })
      })
    },
    openMeetingFacePicDialog (picUrl) {
      this.picUrlOnMeetingFacePicDialog = picUrl
      this.meetingFacePicDialogVisible = true
    },
    syncMeetingFacePicToWechatPhone (schoolId, userId) {
      if (schoolId === null) return
      let _this = this
      this.$confirm('确认要人脸同步到微信电话吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.isSyncMeetingFacePic = true
        this.$axios.post(this.GLOBAL.host + '/wechatPhone/syncMeetingFaceToDevice',
          this.$qs.stringify({ schoolId: schoolId, userId: userId })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              _this.getUserList()
            } else {
              this.$message.error(res.data.message)
            }
            _this.isSyncMeetingFacePic = false
          }
        })
      })
    },
    syncMeetingFacePicToTianqiao (schoolId, userId) {
      if (schoolId === null) return
      let _this = this
      this.$confirm('确认要人脸同步到天乔吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.isSyncMeetingFacePic = true
        this.$axios.post(this.GLOBAL.host + '/meetingFace/syncToTianqiao',
          this.$qs.stringify({ schoolId: schoolId, userId: userId, forStudent: 1 })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
              _this.getUserList()
            } else {
              this.$message.error(res.data.message)
            }
            _this.isSyncMeetingFacePic = false
          }
        })
      })
    }
  },
  computed: {
    outerSelectingClassList () {
      let tempArray = []
      if (this.searchForm.schoolId != null) {
        this.classList.forEach(classInfo => {
          if (classInfo.schoolId === this.searchForm.schoolId) {
            tempArray.push(classInfo)
          }
        })
      } else {
        tempArray = this.classList
      }
      return tempArray
    },
    innerSelectingClassList () {
      let tempArray = []
      let actForm = {}
      if (this.addDialogVisible) {
        actForm = this.addData
      } else if (this.modifyDialogVisible) {
        actForm = this.modifyData
      } else {
        return []
      }
      if (actForm.schoolId != null) {
        this.classList.forEach(classInfo => {
          if (classInfo.schoolId === actForm.schoolId) {
            tempArray.push(classInfo)
          }
        })
      } else {
        tempArray = this.classList
      }
      return tempArray
    }
  },
  watch: {
    outerSelectingClassList () {
      if (this.searchForm.classId != null && this.outerSelectingClassList.map(item => item.id).indexOf(this.searchForm.classId) === -1) {
        this.searchForm.classId = ''
      }
    },
    innerSelectingClassList () {
      let actForm = {}
      if (this.addDialogVisible) {
        actForm = this.addData
      } else if (this.modifyDialogVisible) {
        actForm = this.modifyData
      }
      if (actForm.classId != null && this.innerSelectingClassList.map(item => item.id).indexOf(actForm.classId) === -1) {
        actForm.classId = ''
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Student.vue